import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { ToastService } from 'src/app/services/toast.service';
import Job from 'src/app/interfaces/Job';
import { JobService } from 'src/app/services/job.service';
import { LoadingService } from 'src/app/services/loading.service';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-edit-job',
  templateUrl: './edit-job.component.html',
  styleUrls: ['./edit-job.component.scss'],
})
export class EditJobComponent implements OnInit, OnDestroy {
  isNewJob = false;
  step = 0;
  subscriptions: Subscription = new Subscription();
  currentUser;
  job: Job = {
    id: null,
    title: null,
    owner: null,
    ownerMeta: {
      name: null,
    },
    timestamp: null,
    contact: {
      firstName: null,
      lastName: null,
      email: null,
    },
    summary: null,
    applicationLink: null,
    company: null,
    archived: false,
    autoArchiveOverride: false
  };
  editorModules = {
    toolbar: [['link', 'bold', 'italic', 'underline', 'strike', 'blockquote', { list: 'ordered' }, { list: 'bullet' }]],
  };

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private jobService: JobService,
    private location: Location,
    private router: Router,
    private renderer: Renderer2,
    private toastService: ToastService,
    private loadingService: LoadingService,
    private notificationService: NotificationsService
  ) {}

  ngOnInit() {
    // See if new job
    this.route.queryParams.subscribe((params) => {
      if (params['new']) {
        this.isNewJob = params['new'];
      } else {
        if (params['id']) {
          this.jobService.getCurrentJob(params['id']).subscribe((j) => {
            this.job = j[0];
          });
        }
      }
    });

    // Get user
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;
        }
      })
    );
  }

  saveJob() {
    this.loadingService.startLoading();
    if (this.isNewJob) {
      this.job.owner = this.currentUser.uid;
      this.job.ownerMeta.name = this.currentUser.displayName;
      this.job.contact = {
        firstName: this.currentUser.firstName,
        lastName: this.currentUser.lastName,
        email: this.currentUser.email,
        webpage: this.currentUser.webpage,
      };
      this.job.timestamp = new Date();

      this.jobService.createJob(this.job).then(
        (id: string) => {
          this.notificationService.sendNotifications({
            type: 'newJobs',
            author: this.currentUser.uid,
            title: this.job.title,
            url: `/jobs/${id}`,
          });
          this.loadingService.stopLoading();
          // this.router.navigateByUrl(`/jobs/${id}`);
          this.router.navigate(['/jobs/' + id]);

        },
        (e) => console.error(e)
      );
    } else {
      this.jobService.updateJob(this.job.id, this.job).then(
        (res) => {
          this.userService.saveUser(this.currentUser.uid, this.currentUser).then(() => {
            this.loadingService.stopLoading();
            // this.router.navigateByUrl(`/jobs/${this.job.id}`);
            this.router.navigate(['/jobs/' + this.job.id]);
          });
        },
        (e) => console.error(e)
      );
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
